// Parse chat id from url path
export function parseChatId() {
	let url = window.location.href
	let chatId = url.split("/")[4]
	return chatId
}
